import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'

export const useOnboardingRoute = ({
  setTempOnboarding,
  setTempSkills,
  onApplyFilters,
  ous,
  skills,
  skillList,
}: any) => {
  const location = useLocation()
  const lastSearchRef = useRef<string>('')

  useEffect(() => {
    if (lastSearchRef.current === location.search) return

    const params = new URLSearchParams(location.search)
    const onboardingParam = params.get('onboarding')
    const skillsParam = params.get('skills')

    const skillsData = (Array.isArray(skillList) ? skillList : skillList?.data) || []
    const skillIds = skillsParam
      ? skillsParam
          .split(',')
          .map((label: string) => skillsData.find((skill: any) => skill.name === label.trim())?.id)
          .filter((id: any): id is string => !!id)
      : []

    if (onboardingParam === 'true' || skillIds.length > 0) {
      if (onboardingParam === 'true') {
        setTempOnboarding('true')
      }

      if (skillIds.length > 0) {
        setTempSkills(skillIds)
      }

      onApplyFilters(onboardingParam === 'true' ? 'true' : 'false', ous, skillIds.length > 0 ? skillIds : skills)
    }

    lastSearchRef.current = location.search
  }, [location.search, onApplyFilters, setTempOnboarding, setTempSkills, skillList, ous, skills])
}
